<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="text-center mb-0">Tasks</h3>
      <b-button size="sm" variant="primary" v-b-modal.task-modal>New Task</b-button>
    </div>
    <loading-panel v-if="loading"></loading-panel>
    <div v-else>
      <h4 class="mb-0">Today's Tasks</h4>
      <b-list-group flush data-toggle="tasks" v-if="tasks.length > 0" class="mb-2">
        <b-list-group-item class="px-0"
            v-for="task in tasks"
            :key="task.id"
        >
          <div class="checklist-item checklist-item-warning">
            <div class="checklist-info">
              <h5 class="checklist-title mb-0">{{task.name}}</h5>
              <small><strong>Type:</strong> {{task.type}}</small><br>
              <small><strong>Assigned To:</strong> {{task.AssignedTo}}</small>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
      <h5 class="text-danger text-center mt-3 mb-4" v-else>No Tasks Today</h5>
      <h4 class="mb-0">Upcoming Tasks</h4>
      <b-list-group flush data-toggle="upcoming" v-if="upcoming.length > 0" class="mb-2">
        <b-list-group-item class="px-0"
            v-for="task in upcoming"
            :key="task.id"
        >
          <div class="checklist-item checklist-item-success">
            <div class="checklist-info">
              <h5 class="checklist-title mb-0">{{task.name}}</h5>
              <small><strong>Type:</strong> {{task.type}}</small><br>
              <small><strong>Assigned To:</strong> {{task.AssignedTo}}</small>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
      <h5 class="text-danger text-center mt-3 mb-4" v-else>No Upcoming Tasks</h5>
      <h4 class="mb-0" v-if="overdue.length > 0">Overdue Tasks</h4>
      <b-list-group flush data-toggle="overdue" v-if="overdue.length > 0" class="mb-2">
        <b-list-group-item class="px-0"
            v-for="task in overdue"
            :key="task.id"
        >
          <div class="checklist-item checklist-item-danger">
            <div class="checklist-info">
              <h5 class="checklist-title mb-0">{{task.name}}</h5>
              <small><strong>Type:</strong> {{task.type}}</small><br>
              <small><strong>Assigned To:</strong> {{task.AssignedTo}}</small>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>
    <b-modal id="task-modal" title="New Task" @shown="getUsers" @hidden="clearForm" hide-footer>
      <b-form @submit.prevent="submitTask">
        <div>
          <b-form-group>
            <label class="form-control-label" for="personId">Task Owner:</label>
            <b-form-select v-model="task.personId" v-if="users.length > 0" required>
              <b-form-select-option :value="null">Select a Task Owner</b-form-select-option>
              <b-form-select-option :value="user.id" v-for="user in users" :key="user.id">{{ user.name }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>
        <div>
          <b-form-group>
            <label class="form-control-label" for="assignedUserId">Assigned To:</label>
            <b-form-select v-model="task.assignedUserId" v-if="users.length > 0" required>
              <b-form-select-option :value="null">Select a User to Assign Task</b-form-select-option>
              <b-form-select-option :value="user.id" v-for="user in users" :key="user.id">{{ user.name }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>
        <b-form-group>
          <label class="form-control-label" for="name">Task Name:</label>
          <b-form-input v-model="task.name" placeholder="Task Name" required></b-form-input>
        </b-form-group>
        <div>
          <b-form-group>
            <label class="form-control-label" for="type">Type:</label>
            <b-form-select v-model="task.type" required>
              <b-form-select-option :value="null">Select a Task Type</b-form-select-option>
              <b-form-select-option :value="type" v-for="(type, index) in types" :key="index">{{ type }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>
        <b-form-group>
          <label class="form-control-label" for="dueDate">Due Date:</label>
          <b-form-datepicker id="dueDate-datepicker" v-model="task.dueDate" class="mb-2"></b-form-datepicker>
        </b-form-group>
        <b-button block variant="success" type="submit">Save Task</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import { mapGetters } from 'vuex';
import LoadingPanel from '@/components/LoadingPanel';

export default {
  components: {
    LoadingPanel,
  },
  data() {
    return {
      tasks: [],
      upcoming: [],
      overdue: [],
      users: [],
      loading: false,
      task: {
        personId: null,
        assignedUserId: null,
        name: '',
        type: null,
        isCompleted: false,
        dueDate: new Date(),
      },
      types: [
        'Follow Up',
        'Call',
        'Text',
        'Email',
        'Appointment',
        'Showing',
        'Closing',
        'Open House',
        'Thank You'
      ],
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute'
    })
  },
  methods: {
    getTasks() {
      axios.get(this.userRoute + "/integrations/fub/tasks?due=today")
      .then(response => {
        this.tasks = response.data;
      })
      .catch(error => {
        // error
      });
    },
    getUpcomingTasks() {
      axios.get(this.userRoute + "/integrations/fub/tasks?due=upcoming")
      .then(response => {
        this.upcoming = response.data;
      })
      .catch(error => {
        // error
      });
    },
    getOverdueTasks() {
      axios.get(this.userRoute + "/integrations/fub/tasks?due=overdue")
      .then(response => {
        this.overdue = response.data;
        this.loading = false;
      })
      .catch(error => {
        // error
      });
    },
    getUsers() {
      axios.get(this.userRoute + "/integrations/fub/users")
      .then(response => {
        this.users = response.data;
      })
      .catch(error => {
        // error
      });
    },
    submitTask() {
      axios.post(this.userRoute + "/integrations/fub/tasks", this.task)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.getTasks();
          this.getUpcomingTasks();
          this.getOverdueTasks();
          this.clearForm();
          this.$bvModal.hide('task-modal');
        });
      })
      .catch(error => {
        // error
      });
    },
    clearForm() {
      this.task = {
        personId: null,
        assignedUserId: null,
        name: '',
        type: null,
        isCompleted: false,
        dueDate: new Date(),
      };
    }
  },
  created() {
    this.loading = true;
    this.getTasks();
    this.getUpcomingTasks();
    this.getOverdueTasks();
  }
};
</script>